import './Jason.css'
import panda from '../assets/panda.jpg'

function JasonProfile() {
    return (
      <div>
        <h1> Jason Zheng</h1>
        <img src={panda} height={200} width={300}/>
        <p> Hi my name is Jason Zheng. I am a senior computer science major at <br></br>
            the University of Buffalo. I am a transfer student from Binghamton.
            <br></br> I play the violin and like playing video games. 
            <br></br>My picture that represents me is a panda because I like pandas.
        </p>
      </div>
    );
  }
  
  export default JasonProfile